import React from "react";
import { cn } from "@/lib/utils";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	variant?: "primary" | "secondary" | "outline" | "ghost";
	size?: "sm" | "md" | "lg" | "xl";
	children?: React.ReactNode;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
	(
		{ className, variant = "primary", size = "md", children, ...props },
		ref
	) => {
		const baseClasses =
			"inline-flex items-center justify-center rounded-full font-medium transition-colors focus-brand disabled:pointer-events-none disabled:opacity-50";

		const variants = {
			primary:
				"bg-brand-green text-brand-text-dark hover:bg-brand-green/90 shadow-sm",
			secondary:
				"bg-brand-dark-alt text-white hover:bg-brand-dark-alt/80 border border-white-20",
			outline:
				"border border-brand-border bg-transparent text-white hover:bg-white/10",
			ghost: "text-white hover:bg-white/10",
		};

		const sizes = {
			sm: "h-10 px-4 text-sm",
			md: "h-12 px-6 text-base",
			lg: "h-14 px-8 text-lg",
			xl: "h-16 px-10 text-xl",
		};

		return (
			<button
				className={cn(
					baseClasses,
					variants[variant],
					sizes[size],
					className
				)}
				ref={ref}
				{...props}
			>
				{children}
			</button>
		);
	}
);

Button.displayName = "Button";

export default Button;
